// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation } from "swiper";

import "swiper/css";
import "./sliderChart.scss";
import { FormattedMessage } from "react-intl";
// import Divider from "component/divider/divider";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import { useSelector } from "react-redux";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import useSWR from "swr";
import { END_POINTS } from "constants/APIConstant";
import IndicatorCard from "./components/indicatorCard";

function SliderChart() {
  const dir = useSelector(({ theme }) => theme.direction);

  const sliderData = useSWR({
    url: END_POINTS.SELECTED_INDICATOR,
  });

  const options = {
    loop: false,
    autoplay: false,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    // center: true,
    // margin: 30,
    nav: true,
    dots: false,
    responsiveClass: true,
    smartSpeed: 500,
    dir: "ltr",
    responsive: {
      0: {
        items: 1,
      },
      550: {
        items: 2,
      },
      768: {
        items: 3,
      },
      992: {
        items: 4,
      },
      1200: {
        items: 5,
      },
    },
  };

  const fetchingData = () => {
    const indicatorsData =
      sliderData.error ||
      sliderData.isLoading ||
      sliderData.data === undefined ||
      sliderData.data === null
        ? []
        : sliderData.data.data;

    const render =
      Object.keys(indicatorsData).length > 4 ? (
        <OwlCarousel className="owl-theme" {...options}>
          {indicatorsData.map(
            (
              {
                icon,
                selectedIndicatorTranslations,
                studyPeriod,
                title,
                unit,
                value,
              },
              i
            ) => (
              <IndicatorCard
                key={i}
                icon={icon}
                translation={selectedIndicatorTranslations}
                studyPeriod={studyPeriod}
                title={title}
                unit={unit}
                value={value}
              />
            )
          )}
        </OwlCarousel>
      ) : Object.keys(indicatorsData).length > 0 ? (
        <div className="row">
          {indicatorsData.map(
            (
              {
                icon,
                selectedIndicatorTranslations,
                studyPeriod,
                title,
                unit,
                value,
              },
              i
            ) => (
              <div key={i} className="col-12 col-md-3">
                <IndicatorCard
                  key={i}
                  icon={icon}
                  translation={selectedIndicatorTranslations}
                  studyPeriod={studyPeriod}
                  title={title}
                  unit={unit}
                  value={value}
                />
              </div>
            )
          )}
        </div>
      ) : (
        <DataNotFound />
      );

    return render;
  };

  return (
    <ContentLoading isLoading={sliderData.isLoading}>
      <div
        className={`slider-chart-slider ${
          sliderData?.data?.data?.length < 6 && "nav-none"
        }`}
      >
        <div className="container">
          {/* <Divider /> */}
          <div className="section-title">
            <FormattedMessage id="indicators" />
          </div>
          {/* <Swiper
            modules={[Navigation]}
            navigation={{
              prevEl: ".prev",
              nextEl: ".next",
            }}
            spaceBetween={20}
            breakpoints={{
              0: {
                // width: 640,
                slidesPerView: 1,
              },
              // when window width is >= 640px
              640: {
                width: 640,
                slidesPerView: 1,
              },
              // when window width is >= 768px
              768: {
                width: 768,
                slidesPerView: 3,
              },
            }}
            slidesPerView={5}
          >
            <SwiperSlide>
              <div className="s-card">
                <div className="scard_head">
                  <h4>7,740</h4>
                  <h6>مليون دولار</h6>
                </div>
                <div className="scard_body">
                  <img
                    className="img1"
                    src={process.env.PUBLIC_URL + "/image/up1.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                  <img
                    className="up"
                    src={process.env.PUBLIC_URL + "/image/top.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                </div>
                <div className="scard_foot">
                  <h5>التجارة الخارجية - واردات</h5>
                  <h6>(مارس 2022)</h6>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="s-card">
                <div className="scard_head">
                  <h4>7,740</h4>
                  <h6>مليون دولار</h6>
                </div>
                <div className="scard_body">
                  <img
                    className="img1"
                    src={process.env.PUBLIC_URL + "/image/up2.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                  <img
                    className="up"
                    src={process.env.PUBLIC_URL + "/image/top.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                </div>
                <div className="scard_foot">
                  <h5>التجارة الخارجية - واردات</h5>
                  <h6>(مارس 2022)</h6>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="s-card">
                <div className="scard_head">
                  <h4>7,740</h4>
                  <h6>مليون دولار</h6>
                </div>
                <div className="scard_body">
                  <img
                    className="img1"
                    src={process.env.PUBLIC_URL + "/image/up3.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                  <img
                    className="up"
                    src={process.env.PUBLIC_URL + "/image/bootom.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                </div>
                <div className="scard_foot">
                  <h5>التجارة الخارجية - واردات</h5>
                  <h6>(مارس 2022)</h6>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="s-card">
                <div className="scard_head">
                  <h4>7,740</h4>
                  <h6>مليون دولار</h6>
                </div>
                <div className="scard_body">
                  <img
                    className="img1"
                    src={process.env.PUBLIC_URL + "/image/up4.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                  <img
                    className="up"
                    src={process.env.PUBLIC_URL + "/image/top.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                </div>
                <div className="scard_foot">
                  <h5>التجارة الخارجية - واردات</h5>
                  <h6>(مارس 2022)</h6>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="s-card">
                <div className="scard_head">
                  <h4>7,740</h4>
                  <h6>مليون دولار</h6>
                </div>
                <div className="scard_body">
                  <img
                    className="img1"
                    src={process.env.PUBLIC_URL + "/image/up5.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                  <img
                    className="up"
                    src={process.env.PUBLIC_URL + "/image/bootom.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                </div>
                <div className="scard_foot">
                  <h5>التجارة الخارجية - واردات</h5>
                  <h6>(مارس 2022)</h6>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="s-card">
                <div className="scard_head">
                  <h4>7,740</h4>
                  <h6>مليون دولار</h6>
                </div>
                <div className="scard_body">
                  <img
                    className="img1"
                    src={process.env.PUBLIC_URL + "/image/up6.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                  <img
                    className="up"
                    src={process.env.PUBLIC_URL + "/image/top.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                </div>
                <div className="scard_foot">
                  <h5>التجارة الخارجية - واردات</h5>
                  <h6>(مارس 2022)</h6>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="s-card">
                <div className="scard_head">
                  <h4>7,740</h4>
                  <h6>مليون دولار</h6>
                </div>
                <div className="scard_body">
                  <img
                    className="img1"
                    src={process.env.PUBLIC_URL + "/image/up7.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                  <img
                    className="up"
                    src={process.env.PUBLIC_URL + "/image/top.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                </div>
                <div className="scard_foot">
                  <h5>التجارة الخارجية - واردات</h5>
                  <h6>(مارس 2022)</h6>
                </div>
              </div>
            </SwiperSlide>

            <div className="prev">
              <i className="fa fa-angle-left"></i>
            </div>
            <div className="next">
              <i className="fa fa-angle-right"></i>
            </div>
          </Swiper> */}

          <div
            className={`selected-indicators-slider ${
              dir === "rtl" ? "dir-r" : "dir-l"
            }`}
          >
            {fetchingData()}
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default SliderChart;
